import React from "react"
import Modal, { ModalContent, ModalHeader, ModalBtnGroup } from "../Modal"

const noop = () => {}

const Confirm = (props) => {
  if (!props.isOpen) return null
  return (
    <Modal isOpen={props.isOpen} close={noop} classes={["medium"]}>
      <ModalContent>
        <ModalHeader text={props.title} />
        <p>{props.message}</p>
        <ModalBtnGroup alignRight={true}>
          <button
            onClick={props.cancel.action}
            className="btn btn-secondary"
            data-cy="modal-cancel"
          >
            {props.cancel.text}
          </button>
          <button
            onClick={props.confirm.action}
            className="btn btn-primary"
            data-cy="modal-confirm"
          >
            {props.confirm.text}
          </button>
        </ModalBtnGroup>
      </ModalContent>
    </Modal>
  )
}

export default Confirm
